import React from "react";
import CommonHeading from "../../common-component/common-heading/CommonHeading";
import "./Specialization.css";

import {
  faChartLine,
  faCoins,
  faBullhorn,
  faUsers,
  faTruckFast,
  faChartPie,
  faBullseye,
  faMoneyBillTrendUp,
  faUserGroup,
  faUserTie,
  faPeopleGroup,
  faChartSimple,
  faMoneyCheckDollar,
  faBoxesPacking,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { motion } from "framer-motion";

const specializations = [
  {
    title: "Business Analytics",
    icon: faChartLine,
    description:
      "Develop data-driven decision-making skills using analytics, visualization and business intelligence.",
  },
  {
    title: "Finance Management",
    icon: faCoins,
    description:
      "Build expertise in financial planning, investment analysis, accounting and strategic financial management.",
  },
  {
    title: "Marketing Management",
    icon: faBullhorn,
    description:
      "Learn modern marketing strategies, consumer behavior, branding, digital marketing and market research.",
  },
  {
    title: "Human Resource Management",
    icon: faUsers,
    description:
      "Develop skills in talent acquisition, employee engagement, performance management and organizational development.",
  },
  {
    title: "Operations & Supply Chain Management",
    icon: faTruckFast,
    description:
      "Master operations, logistics, procurement and supply chain strategies to improve business efficiency.",
  },
  {
    title: "Business Analytics + Finance",
    icon: faChartPie,
    description:
      "Combine business analytics with financial expertise to make smarter, data-driven financial decisions.",
  },
  {
    title: "Business Analytics + Marketing",
    icon: faBullseye,
    description:
      "Use analytics and marketing insights to understand customers, optimize campaigns and drive business growth.",
  },
  {
    title: "Finance + Marketing",
    icon: faMoneyBillTrendUp,
    description:
      "Integrate financial management and marketing strategies to create profitable and sustainable business growth.",
  },
  {
    title: "Business Analytics + Human Resource Management",
    icon: faUserGroup,
    description:
      "Apply data analytics to talent management, workforce planning and strategic human resource decisions.",
  },
  {
    title: "Finance + Human Resource Management",
    icon: faUserTie,
    description:
      "Combine financial and HR expertise to manage workforce costs, compensation and organizational performance.",
  },
  {
    title: "Marketing + Human Resource Management",
    icon: faPeopleGroup,
    description:
      "Connect marketing and HR strategies to strengthen employer branding, employee engagement and organizational growth.",
  },
  {
    title: "Business Analytics + Operations & Supply Chain Management",
    icon: faChartSimple,
    description:
      "Use analytics to optimize operations, forecasting, inventory, logistics and end-to-end supply chain performance.",
  },
  {
    title: "Finance + Operations & Supply Chain Management",
    icon: faMoneyCheckDollar,
    description:
      "Combine financial planning with operations and supply chain expertise to improve cost and operational efficiency.",
  },
  {
    title: "Marketing + Operations & Supply Chain Management",
    icon: faBoxesPacking,
    description:
      "Integrate marketing demand with operations and supply chain planning for efficient product delivery and customer satisfaction.",
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    y: 50,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const Specialization = () => {
  return (
    <section className="Specialization">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7 }}
        >
          <CommonHeading title={"Specialization"} />
        </motion.div>

        <motion.div
          className="specialization_grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.1,
          }}
        >
          {specializations.map((item, index) => (
            <motion.div
              className="specialization_card"
              key={index}
              variants={cardVariants}
              whileHover={{
                y: -8,
                scale: 1.02,
                transition: {
                  duration: 0.25,
                },
              }}
            >
              <motion.div
                className="specialization_icon"
                whileHover={{
                  rotate: 8,
                  scale: 1.12,
                }}
                transition={{ duration: 0.3 }}
              >
                <FontAwesomeIcon icon={item.icon} />
              </motion.div>

              <div className="specialization_content">
                <motion.span
                  className="specialization_number"
                  initial={{ opacity: 0, x: -15 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 }}
                >
                  {String(index + 1).padStart(2, "0")}
                </motion.span>

                <h3>{item.title}</h3>

                <p>{item.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Specialization;
